/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

/**
 * Format date string to Turkish locale format
 * @param {string|Date|null} dateString - Date string or Date object
 * @param {boolean|Object} withTimeOrOptions - If boolean: include time, if object: Intl.DateTimeFormat options
 * @returns {string} Formatted date string or "-" if invalid
 */
export function formatDate(dateString, withTimeOrOptions = true) {
  if (!dateString) return "-";
  
  try {
    const date = dateString instanceof Date ? dateString : new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return "-";
    }

    // If second parameter is boolean, use it for withTime
    // If it's an object, use it as options
    let options;
    if (typeof withTimeOrOptions === "boolean") {
      options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        ...(withTimeOrOptions && {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };
    } else {
      options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        ...withTimeOrOptions,
      };
    }

    return date.toLocaleString("tr-TR", options);
  } catch (error) {
    return "-";
  }
}

/**
 * Format date to date only (without time)
 * @param {string|Date|null} dateString - Date string or Date object
 * @returns {string} Formatted date string or "-" if invalid
 */
export function formatDateOnly(dateString) {
  return formatDate(dateString, false);
}

/**
 * Format date to time only (without date)
 * @param {string|Date|null} dateString - Date string or Date object
 * @returns {string} Formatted time string or "-" if invalid
 */
export function formatTimeOnly(dateString) {
  return formatDate(dateString, {
    hour: "2-digit",
    minute: "2-digit",
  });
}

